import { Routes } from "@angular/router";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { getMyProfileResolver } from "./my-profile/resolvers/my-profile.resolver";

export const dashboardRoutes: Routes = [
  {
    path: "my-profile",
    loadComponent: () => import("./my-profile/components/my-profile/my-profile.component").then(c => c.MyProfileComponent),
    canActivate: [AuthGuard],
    resolve: {
      currentUser: getMyProfileResolver,
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.ROOT,
        TRANSLATION_PATHS.USERS.SHARED,
        TRANSLATION_PATHS.AUTH,
        TRANSLATION_PATHS.AUTHENTICATION.USERS,
        TRANSLATION_PATHS.AUTHENTICATION.SHARED,
      ]),
    },
  },
];
